export function sanitizeLinkHref(href: unknown): string | null {
  if (typeof href !== 'string') return null;
  const trimmed = href.trim();
  if (!trimmed) return null;

  if (/^#[A-Za-z][\w\-:.]*$/.test(trimmed)) return trimmed;

  if (/^(?!\/\/)(?:\/|\.\/|\.\.\/|\?)/.test(trimmed)) return trimmed;

  try {
    const url = new URL(trimmed);
    if (url.protocol === 'http:' || url.protocol === 'https:') return trimmed;
  } catch {
    return null;
  }

  return null;
}
